import { motion } from 'framer-motion';
import { UserPlus, CheckCircle2, Clock, MapPin } from 'lucide-react';

export default function ClientStatsCards({ stats, loading }) {
  const cards = [
    {
      icon: UserPlus,
      label: 'Total Clients',
      statKey: 'total',
      gradient: 'from-blue-50 to-blue-100',
      border: 'border-blue-200',
      iconBg: 'bg-blue-500',
      iconColor: 'text-blue-600',
      textColor: 'text-blue-900',
      labelColor: 'text-blue-700',
    },
    {
      icon: CheckCircle2,
      label: 'Active',
      statKey: 'active',
      gradient: 'from-emerald-50 to-emerald-100',
      border: 'border-emerald-200',
      iconBg: 'bg-emerald-500',
      iconColor: 'text-emerald-600',
      textColor: 'text-emerald-900',
      labelColor: 'text-emerald-700',
    },
    {
      icon: Clock,
      label: 'Pending',
      statKey: 'pending',
      gradient: 'from-amber-50 to-amber-100',
      border: 'border-amber-200',
      iconBg: 'bg-amber-500',
      iconColor: 'text-amber-600',
      textColor: 'text-amber-900',
      labelColor: 'text-amber-700',
    },
    {
      icon: MapPin,
      label: 'Regions',
      statKey: 'regions',
      gradient: 'from-purple-50 to-purple-100',
      border: 'border-purple-200',
      iconBg: 'bg-purple-500',
      iconColor: 'text-purple-600',
      textColor: 'text-purple-900',
      labelColor: 'text-purple-700',
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
      className="grid grid-cols-1 gap-6 mb-8 sm:grid-cols-2 lg:grid-cols-4"
    >
      {cards.map((card, index) => {
        const Icon = card.icon;
        return (
          <motion.div
            key={index}
            whileHover={{ y: -4, scale: 1.02 }}
            className={`relative p-6 bg-gradient-to-br ${card.gradient} rounded-2xl border ${card.border} shadow-lg overflow-hidden`}
          >
            <div className="absolute top-0 right-0 w-32 h-32 bg-opacity-20 rounded-full -mr-16 -mt-16" 
                 style={{ backgroundColor: card.iconColor.replace('text-', '') }}></div>
            <div className="relative flex items-center">
              <div className={`p-3 ${card.iconBg} rounded-xl shadow-md`}>
                <Icon className="w-6 h-6 text-white" />
              </div>
              <div className="ml-4">
                <p className={`text-sm font-medium ${card.labelColor}`}>{card.label}</p>
                <p className={`text-3xl font-bold ${card.textColor}`}>
                  {loading ? '...' : (stats?.[card.statKey] ?? 0)}
                </p>
              </div>
            </div>
          </motion.div>
        );
      })}
    </motion.div>
  );
}
